import {SaleDTO} from "../Sale/saleDTO.interface";
import {BaseResultDTO} from "./baseResultDTO.interface";

export interface SaleSearchResultDTO extends BaseResultDTO
{
  sale?: SaleDTO;
  sales?: SaleDTO[];
}
